// extracted by mini-css-extract-plugin
export default {"textWrap":"Vision-module--textWrap--3PITO","title":"Vision-module--title--1LUF4","mainText":"Vision-module--mainText--2g9mP"};